import { render, staticRenderFns } from "./AiDashboard.vue?vue&type=template&id=b2bd4922&scoped=true&"
import script from "./AiDashboard.vue?vue&type=script&lang=js&"
export * from "./AiDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AiDashboard.vue?vue&type=style&index=0&id=b2bd4922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bd4922",
  null
  
)

export default component.exports